// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clear-icon:hover {
  color: #495057;
}

.clear-icon {
  position: absolute !important;
  right: 0.75rem;
  top: 50%;
  height: 100% !important;
  transform: translateY(-50%);
  z-index: 2;
  width: 1.25rem;
  height: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/ui/custom-controls/styles/SearchInputWithClear.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,eAAe;AACjB","sourcesContent":[".clear-icon:hover {\n  color: #495057;\n}\n\n.clear-icon {\n  position: absolute !important;\n  right: 0.75rem;\n  top: 50%;\n  height: 100% !important;\n  transform: translateY(-50%);\n  z-index: 2;\n  width: 1.25rem;\n  height: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
